import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { isEmpty } from 'ramda';
import PropTypes from 'prop-types';
import { onInitFetchingSocialInternetData } from 'pages/Internet/store/actions/socialInternetActions';
import { getFTTBSocialInternetService } from 'pages/Internet/store/selectors/socialInternetSelectors';

import { SocialInternetPopupConnected } from '../SocialInternetPopupConnected';
import { FlexContainer, ServiceCardWrapper, ServiceGridItem } from '../../components';
import { SocialInternetCard } from './connected';

const SocialInternetCardLayout = ({ onInit, isMobile }) => {
  useEffect(onInit, [onInit]);

  return (
    <ServiceGridItem>
      <>
        <SocialInternetCard isMobile={isMobile}>
          <ServiceCardWrapper isMobile={isMobile}>
            <FlexContainer>
              <SocialInternetCard.Switch />
              <SocialInternetCard.Title />
            </FlexContainer>
          </ServiceCardWrapper>
          <SocialInternetCard.Additional isMobile={isMobile} />
          <SocialInternetCard.Price isMobile={isMobile} />
        </SocialInternetCard>

        <SocialInternetPopupConnected />
      </>
    </ServiceGridItem>
  );
};

SocialInternetCardLayout.propTypes = {
  onInit: PropTypes.func,
  isMobile: PropTypes.bool,
};

export const SocialInternetConnected = connect(
  (state) => ({
    shouldRender: !isEmpty(getFTTBSocialInternetService(state)),
  }),
  { onInit: onInitFetchingSocialInternetData },
)(withRenderFlag(SocialInternetCardLayout));
